/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Saad Pasta",
  title: "Sveiki, aš Lukas",
  subTitle: emoji(
    "Patyręs programinės įrangos inžinierius, turintis patirties su daugybę populiarių technologijų ir siekiantis inovacijų kiekviename projekte 🚀"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/luk3edev",
  linkedin: "https://www.linkedin.com/in/lukas-grinius-74394a175/",
  gmail: "lukas.grinius.dev@proton.me",
  facebook: "https://www.facebook.com/profile.php?id=100004299378830",
  instagram: "https://www.instagram.com/lukass__g/",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Ką aš veikiu",
  subTitle: "Full-Stack programuotojas, kuris mėgsta kurti ir eksperimentuoti su naujausiomis technologijomis",
  skills: [
    emoji(
      "⚡ Vartotojų sąsajų kūrimas visiems įrenginiams naudojant HTML, CSS ir JavaScript"
    ),
    emoji("⚡ WEB aplikacijų kūrimas ir palaikymas naudojant React, Svelte, Vue, Next.js, Wordpress"),
    emoji(
      "⚡ Sistemų programavimas naudojant Express.js, .NET, Gin, Django, Ruby on Rails"
    ),
    emoji(
      "⚡ Duomenų bazių kūrimas ir palaikymas naudojant MySQL, PostgreSQL, Microsoft SQL Server, Firebase"
    ),
    emoji(
      "⚡ Debesų kompiuterijos paslaugų naudojimas ir palaikymas naudojant AWS, Azure, DigitalOcean, Hostinger"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "WordPress",
      fontAwesomeClassname: "fab fa-wordpress"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Vilniaus Gedimino Technikos Universitetas",
      logo: require("./assets/images/image.png"),
      subHeader: "Informatikos mokslų magistras",
      duration: "2022 - 2025",
      desc: "Informacinių sistemų programų inžinerija",
    },
    {
      schoolName: "Vilniaus Gedimino Technikos Universitetas",
      logo: require("./assets/images/image.png"),
      subHeader: "Informatikos mokslų bakalauras",
      duration: "2017 - 2022",
      desc: "Programų inžinerija",

    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Vartotojų sąsajos", //Insert stack or technology you have experience in
      progressPercentage: "65%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Serverinė dalis",
      progressPercentage: "90%"
    },
    {
      Stack: "Programavimas",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Back-end Software Engineer",
      company: "Vinted",
      companylogo: require("./assets/images/vinted.png"),
      date: "2024 birželis – dabar",
      desc: "Šiuo metu gilinu savo žinias dirbdamas su Go ir Ruby on Rails technologijomis, ypatingą dėmesį skirdamas siuntų sričiai.",
      descBullets: [
        "Ruby On Rails",
        "Go (go-chi)",
        "ElasticSearch",
        "Grafana",
        "MySQL",
        "Thanos",
        "Docker",
        "Next.js"
      ]
    },
    {
      role: "Full-Stack Software Engineer",
      company: "Danske Bank",
      companylogo: require("./assets/images/danske.png"),
      date: "2022 kovas - 2024 birželis",
      desc: "Vykdžiau vidinių bankinių apskaitos sistemų kūrimą ir priežiūrą, kūriau integracijas tarp sistemų, plėtojau debesų infrastruktūrą naudojantis IaC. Dalyvavau .NET bendruomenėje.",
      descBullets: [
        "ASP.NET",
        "React su TypeScript",
        "Microsoft SQL Server su Entity Framework",
        "AWS",
        "Cypress",
        "gRPC",
        "Terraform",
        "Azure Devops",
        "Docker"
      ]
    },
    {
      role: "Junior Full-Stack Software Engineer",
      company: "SEB",
      companylogo: require("./assets/images/seb.png"),
      date: "2021 rugsėjis – 2022 kovas",
      desc: "Prižiūrėjau ir tobulinau esamas apskaitos sistemas. Prisidėjau kuriant naują apskaitos sistemą. Įdiegiau procesus (CI/CD), gerinančius programų kūrimą ir diegimą.",
      descBullets: [
        "ASP.NET MVC",
        "Angular 12",
        ".NET Core 3.1",
        "Microsoft SQL Server",
        "Dapper",
        "Docker",
        "OpenShift",
        "WebForms"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Pasiekimai ir certifikatai 🏆 "),
  subtitle:
    "Pasiekimai ir įgyti sertifikatai.",

  achievementsCards: [
    {
      title: "AWS Certified Solutions Developer - Associate",
      image: require("./assets/images/aws.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Susisiekite ☎️"),
  subtitle:
    "Pasikalbėkime apie jūsų lūkesčius ir projektus!",
  email_address: "lukas.grinius.dev@proton.me"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
